import { render, staticRenderFns } from "./CalDavSettings.vue?vue&type=template&id=de5f3ba0&"
import script from "./CalDavSettings.vue?vue&type=script&lang=js&"
export * from "./CalDavSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports